/**
 * @prettier
 */
import { MenuItem } from '@material-ui/core';
import * as React from 'react';
import { translate } from 'src/i18n/translate';
import { usePrintOrderCommand } from 'src/services/printer/usePrintOrderCommand';
import type { OrderVm } from 'src/types/OrderVm';
import { alertKnownErrorOrSomethingWentWrongError } from 'src/utils/alert/alertKnownErrorOrSomethingWentWrongError';
import { useSelector } from 'src/utils/react/useSelector';

export function PrintCommandContextualMenuItem({ order }: Props): React.ReactElement {
    const restaurantId = useSelector((state) => state.app.restaurantId);
    const [printOrderCommand] = usePrintOrderCommand();

    const handlePrintCommand = async () => {
        if (!restaurantId) return alertKnownErrorOrSomethingWentWrongError(translate('Restaurant not selected'));
        await printOrderCommand(order, true);
    };
    return (
        <MenuItem onClick={handlePrintCommand} style={{ textTransform: 'none' }}>
            {translate('Print Command')}
        </MenuItem>
    );
}

type Props = {
    order: OrderVm;
};
